import { render } from "./ManageRolesModal.vue?vue&type=template&id=48732058"
import script from "./ManageRolesModal.vue?vue&type=script&lang=js"
export * from "./ManageRolesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__